<template>
  <div class="verification-code-wrapper">
    <code-input
      ref="code-input"
      class='input'
      type='number'
      id="codeInput"
      :fields='length'
      v-on:complete="onComplete"
    />
  </div>
</template>

<script>
import CodeInput from 'vue-verification-code-input';

export default {
  name: 'verification-code',
  components: {
    CodeInput,
  },
  props: {
    length: {
      type: Number,
      default: 6,
    },
    value: {
      type: String,
    },
    onEnter: {
      type: Function,
    },
  },
  methods: {
    onComplete(verificationCode) {
      this.$emit('onComplete', verificationCode);
    },
    clearInput() {
      this.$refs['code-input'].values = this.$refs['code-input'].values.map(() => '');

      const firstInput = document.querySelector('.verification-code-wrapper .react-code-input').children[0];
      firstInput.focus();
    },
  },
  mounted() {
    if (this.onEnter) {
      document.querySelector('input[data-id="5"]').addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          this.onEnter();
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
  .verification-code-wrapper {
    display: flex;
    margin: auto;
    width: fit-content;
  }
</style>

<style lang="scss">
  .verification-code-wrapper {
    .react-code-input-container {
      height: auto !important;
    }

    .react-code-input {
      input {
        background-color: var(--gray-100) !important;

        border: 1px solid var(--gray-300) !important;
        border-radius: 4px !important;

        width: 48px !important;
        height: 48px !important;

        font-family: 'Manrope' !important;
        font-size: 20px !important;
        text-align: center !important;

        margin: 0px 4px !important;

        caret-color: var(--black) !important;

        &:first-child {
          margin-left: 0px !important;
        }

        &:last-child {
          margin-right: 0px !important;
        }

        &:focus {
          border-color: var(--blue-400) !important;
        }
      }
    }
  }
</style>
